<template>
  <b-row class="pr-lg-4">
    <b-col cols="12">
      <PageTitle title="Lista de banners" />
    </b-col>
    <b-col cols="12" class="mt-2">
        <b-button 
          class="mr-3" 
          variant="danger"
          @click="$refs.videoManual.toggleOpen({ 
            url: 'https://www.youtube.com/watch?v=MCFHsLpjlq8&list=PLW_y7yl6WbLvRvXmlcWDT7-Zi0jR-P721&index=2', 
            title: 'Lista de banners' 
          })"
        >
          <i class="fas fa-play mr-1"></i>
          Ver video
        </b-button>
        <a class="btn btn-success" href="https://api.construp.com.br/assets/Banners.pdf" target="_blank" download><i class="fas fa-file-pdf c-white"></i> Baixar Manual</a>
      </b-col>
    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">Banner criados</h3>
      <b-button
        v-if="whatClerkPermission()"
        pill
        variant="success"
        @click="$router.push({ name: typeRouteById() })"
      >
        <i class="fas fa-plus-circle mr-2"></i>
        Criar banner
      </b-button>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(image)="data">
          <b-img
            :src="`${getImagesAddressApp}${data.item.image}`"
            width="100%"
          ></b-img>
        </template>
        <template #cell(url)="data">
          <span>{{
            data.item.url && data.item.url.length > 40
              ? data.item.url.slice(0, 40) + '...'
              : data.item.url
          }}</span>
        </template>
        <template #cell(platforms)="data">
         <span >{{ typePlatform(data.item.platforms[0]) }}</span>
        </template>
        <template #cell(actions)="data" v-if="whatClerkPermission()">
          <b-button
            class="mr-2"
            variant="primary"
            size="sm"
            title="Editar banner"
            @click="
              $router.push({
                name: typeRouteById(),
                params: { id: data.item.bannerId },
              })
            "
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <b-button
            variant="danger"
            size="sm"
            title="Excluir banner"
            @click="deleteBannerById(data.item.bannerId)"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </template>
      </b-table>
    </b-col>
    <b-col cols="9">
      <p>
        <b-alert show variant="warning">
          <i class="fas fa-exclamation-triangle mr-2"></i>
          O layout abaixo é apenas uma simulação. No aplicativo real pode haver
          diferenças.
        </b-alert>
      </p>
    </b-col>
    <div class="col-md-4">
      <FakeApp
        style="min-height: 800px; max-height: 800px; height: 800px; width: 50px;"
        :header-menu-color="fieldsColor.menuHeaderColor.hex8"
        :background-color="fieldsColor.backgroundColor.hex8"
        :icon-color="fieldsColor.iconColor.hex8"
        :font-color="fieldsColor.fontColor.hex8"
        />
    </div>
    <VideoManual ref="videoManual"/>
  </b-row>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import VideoManual from '@/components/VideoManual.vue';
import makeToast from '@/mixins/makeToast';

import { mapActions, mapGetters, mapState } from 'vuex';
import USER_TYPES from 'Enums/UserTypes.js';
import FakeApp from '@/views/lojista/customizations/ChangeColor/FakeApp.vue';
import UserTypes from '@/enums/UserTypes';
import TypePermission from '@/enums/Clerk/TypePermission';
import NamePermission from '@/enums/Clerk/NamePermission';
import BANNER_PLATFORMS from '@/enums/BannerPlatforms.js';

export default {
  name: 'CustomizationListBanner',
  mixins: [makeToast],
  components: {
    PageTitle,
    FakeApp,
    VideoManual
  },
  data() {
    return {
      BANNER_PLATFORMS,
      loading: false,
      fieldsColor: {
        menuHeaderColor: {},
        backgroundColor: {},
        iconColor: {},
        fontColor: {},
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'bannerId',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'image',
            label: 'Imagem',
            sortable: false,
          },
          {
            key: 'url',
            label: 'Url',
            sortable: false,
          },
          {
            key: 'userTypesText',
            label: 'Tipos de usuários',
            sortable: false,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
          },
          {
            key: 'platforms',
            label: 'Plataformas',
            sortable: false,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
          },
          {
            key: 'createdAt',
            label: 'Criado em',
            sortable: true,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
          },
          {
            key: 'order',
            label: 'Ordernação',
            sortable: true,
            thClass: 'text-center fs-14 d-none d-lg-table-cell',
            tdClass: 'text-center d-none d-lg-table-cell',
            headerClass: "d-none d-lg-table-cell", 
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    ...mapGetters('general', ['getImagesAddressApp']),
  },
  mounted() {
    this.list();
    this.get();
  },
  methods: {
    ...mapActions('shopkeeper', ['listBanner', 'deleteBanner', 'getCustomization', 'saveCustomization']),
    list() {
      this.loading = true;

      this.listBanner(this.userTypeId())
        .then((response) => {
          this.table.records = this.handleRecords(response.data.data || []);
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os banners',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    get() {
      this.getCustomization(this.userTypeId())
        .then((response) => {
          if (!response.data.data) return;
          this.handleColors(response.data.data);
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
          this.loading = false;
        });
    },
    deleteBannerById(bannerId) {
      if (!bannerId) return;

      this.$store.dispatch('startLoader');
      this.deleteBanner(bannerId)
        .then(() => {
          this.list();
        })
        .catch(() => {
          this.makeToast('Erro', 'Houve um erro ao excluir o banner', 'danger');
        })
        .finally(() => {
          this.$store.dispatch('endLoader');
        });
    },
    typePlatform(value){
      if(!value || parseInt(value.platform) === BANNER_PLATFORMS.ALL ) return "Aplicativo e Site";
      if(parseInt(value.platform) === BANNER_PLATFORMS.APP ) return "Aplicativo";
      if(parseInt(value.platform) === BANNER_PLATFORMS.WEB ) return "Site";
    },
    handleColors({ menuHeaderColor, backgroundColor, iconColor, fontColor }) {
      this.$set(this.fieldsColor.menuHeaderColor, 'hex8', menuHeaderColor);
      this.$set(this.fieldsColor.menuHeaderColor, 'hex', menuHeaderColor);

      this.$set(this.fieldsColor.backgroundColor, 'hex8', backgroundColor);
      this.$set(this.fieldsColor.backgroundColor, 'hex', backgroundColor);

      this.$set(this.fieldsColor.iconColor, 'hex8', iconColor);
      this.$set(this.fieldsColor.iconColor, 'hex', iconColor);

      this.$set(this.fieldsColor.fontColor, 'hex8', fontColor);
      this.$set(this.fieldsColor.fontColor, 'hex', fontColor);
    },

    /**
     * @param {Array} records
     */
    handleRecords(records) {
      if (!records || !records.length) return;

      records.forEach((record) => {
        record.userTypes.forEach((type, index) => {
          if (index === 0) record.userTypesText = '';

          record.userTypesText += this.handleUserTypeString(type.user_type);

          if (index !== record.userTypes.length - 1)
            record.userTypesText += ', ';
        });
      });

      return records;
    },
    handleUserTypeString(userType) {
      const names = {
        [`${USER_TYPES.CLIENT}`]: 'Cliente',
        [`${USER_TYPES.PROFESSIONAL}`]: 'Profissional',
        [`${USER_TYPES.SHOPKEEPER}`]: 'Empresa',
      };
      return names[`${userType}`] || '';
    },
    userTypeId(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? this.dadosUsuario.construp_user_id : this.dadosUsuario.id;
    },
    typeRouteById(){
      return this.$route.meta.userType  == UserTypes.BALCONISTA ? 'balconista-customizacoes-salvar-banner' : 'lojista-customizacoes-salvar-banner';
    },
    whatClerkPermission(){
      if(this.$route.meta.userType  == UserTypes.BALCONISTA){
        const permissionClerk = JSON.parse(localStorage.getItem('permissionClerk'));
        const permission = permissionClerk.find(element => element.name == NamePermission.CUSTOMIZACAO_BANNER);

        if(this.$route.meta.userType == UserTypes.BALCONISTA && permission.type == TypePermission.BALCONISTA){
          return false;
        }
      }
      return true;
    }
  },
};
</script>